import { SVGProps } from 'react';

import { NestedLocation } from '../../types/nestedLocations';
import { Branch } from './icons/Branch';
import { DistributionCenter } from './icons/DistributionCenter';
import { Enterprise } from './icons/Enterprise';
import { Office } from './icons/Office';
import { Other } from './icons/Other';
import { Plant } from './icons/Plant';
import { ProductionLine } from './icons/ProductionLine';
import { Warehouse } from './icons/Warehouse';

interface LocationIconProps extends SVGProps<SVGSVGElement> {
  placeType: NestedLocation['place_type_id'];
}

// review (#1867). Forwards to the underlying icon (each already has its own
// viewBox and defaults props after the hardcoded width/height), so a caller
// can size it directly instead of wrapping it in a fixed-size div and
// scaling with a CSS transform.
export function LocationIcon({ placeType, ...props }: LocationIconProps) {
  switch (placeType) {
    case 'plant':
      return <Plant {...props} />;
    case 'distribution_center':
      return <DistributionCenter {...props} />;
    case 'warehouse':
      return <Warehouse {...props} />;
    case 'office':
      return <Office {...props} />;
    case 'branch':
      return <Branch {...props} />;
    case 'production_line':
      return <ProductionLine {...props} />;
    case 'enterprise':
      return <Enterprise {...props} />;
    default:
      return <Other {...props} />;
  }
}
